import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EducationalQualDTO  {
    _originalTypeClassName = "zERP.BO.EducationalQualDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EducationalQualDTO.translate = translateService;
}
this.Id = null;
this.TitleName = null;
this.Duration = null;
this.GraduationDate = null;
this.acknowledged = false;
this.Code_ = null;
this.DocumentType = null;
this.DocumentDescription = null;
this.AcquisitionYear = null;
this.State = null;
this.HRComment = null;
this.EmpComment = null;
this.StateInt = null;
this.StateName = null;
this.StatePrevious = null;
this.GraduationYear = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TitleName:any;
Duration:any;
GraduationDate:any;
acknowledged:any;
Code_:any;
DocumentType:any;
DocumentDescription:any;
AcquisitionYear:any;
State:any;
HRComment:any;
EmpComment:any;
StateInt:any;
StateName:any;
StatePrevious:any;
GraduationYear:any;
Institution:any;
StudiesField:any;
StudiesLevel:any;
EducationalDirection:any;
static setInstitution = ($this, value) => {
var oldValue = $this.Institution;
$this.Institution = value;
if (value != null) {
}
}
static setStudiesField = ($this, value) => {
var oldValue = $this.StudiesField;
$this.StudiesField = value;
if (value != null) {
}
}
static setStudiesLevel = ($this, value) => {
var oldValue = $this.StudiesLevel;
$this.StudiesLevel = value;
if (value != null) {
}
}
static setEducationalDirection = ($this, value) => {
var oldValue = $this.EducationalDirection;
$this.EducationalDirection = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}